import React, { useState, useEffect } from "react";

import { TeamCard } from "../../atoms/Cards";
import { H3, P } from "../../atoms/Texts";
import { useParams } from "react-router-dom";
import useTeamMembers from "../../../shared/hooks/useTeamMembers";
import EditMemberModal from "../../organisms/EditMemberModal";

export const TeamList = () => {
  const { id } = useParams();

  const {
    allTeamMembers,
    isfetchingTeamMembers,
    getAllTeamMembers,
    fetchingTeamMembersError,
  } = useTeamMembers();

  const [, setTeam] = useState([]);
  const [selectedMember, setSelectedMember] = useState({});

  useEffect(() => {
    getAllTeamMembers(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (fetchingTeamMembersError) {
      console.log(fetchingTeamMembersError.message);
      setTeam([]);
    }
  }, [fetchingTeamMembersError]);

  const editMember = (member) => {
    setSelectedMember(member);
  };

  const closeEditMemberModal = () => {
    setSelectedMember({});
  };

  return (
    <div className="grid grid-cols-1 gap-y-6">
      {isfetchingTeamMembers ? (
        <div className="mt-6">
          <div className="">
            <div className="animate-pulse rounded-md bg-gray-600 opacity-75 h-10 w-full mb-4"></div>
          </div>
          <div className="">
            <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full h-10 mb-2 mt-4"></div>
          </div>
          <div className="">
            <div className="animate-pulse rounded-md bg-gray-600 opacity-75 w-full h-10 mb-2 mt-4"></div>
          </div>
        </div>
      ) : (
        <>
          {allTeamMembers?.length < 1 ? (
            <div className="flex flex-col items-center">
              <H3 color="#22202D" className="">
                You do not have any team members
              </H3>
              <P fontSize="16px" color="#7D7B96" className="mt-3 mb-0 text-center">
                Add members by inviting them to join your organization.
              </P>
            </div>
          ) : (
            <>
              {allTeamMembers?.map((member) => (
                <TeamCard
                  key={member.id}
                  editMember={(member) => editMember(member)}
                  member={member}
                  title={`${member?.firstName} ${member?.lastName}`}
                  description={member.role}
                  email={member.email}
                />
              ))}
            </>
          )}
        </>
      )}
      {selectedMember?.id && (
        <EditMemberModal closeModal={closeEditMemberModal} member={selectedMember} />
      )}
    </div>
  );
};
